module Easypass {
    export enum IFluiditeTendanceValues {
        Inconnu = 0,
        Augmente = 1,
        Stable = 2,
        Diminue = 3
    }
}
